var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-read-more-smooth',{attrs:{"text":"More","text-less":"Less"}},[_c('div',{staticClass:"body-2 font-weight-regular ml-0 mt-0 mr-2 black--text justify",domProps:{"innerHTML":_vm._s(_vm.textMore)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }